import React from 'react';

import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const SubmissionTable = ({ 
  submissions, 
  selectedIds, 
  onSelectAll, 
  onSelectOne, 
  onViewDetails,
  onApprove,
  onReject 
}) => {
  const getStatusColor = (status) => {
    const colors = {
      'pending': 'bg-warning/10 text-warning',
      'approved': 'bg-success/10 text-success',
      'rejected': 'bg-destructive/10 text-destructive',
      'in-review': 'bg-primary/10 text-primary'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  const getCompanyColor = (company) => {
    const colors = {
      'Eppme Digital Technologies Ltd': 'bg-blue-500/10 text-blue-600',
      'Zetavista Analytics': 'bg-purple-500/10 text-purple-600',
      'DeGrey Digital Technologies Ltd': 'bg-emerald-500/10 text-emerald-600'
    };
    return colors?.[company] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg shadow-brand overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-6 py-4 text-left">
                <Checkbox
                  checked={selectedIds?.length === submissions?.length && submissions?.length > 0}
                  onChange={onSelectAll}
                  indeterminate={selectedIds?.length > 0 && selectedIds?.length < submissions?.length}
                />
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Employee</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Company</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Department</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Status</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Completion</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Submitted</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {submissions?.map((submission) => (
              <tr key={submission?.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-6 py-4">
                  <Checkbox
                    checked={selectedIds?.includes(submission?.id)}
                    onChange={() => onSelectOne(submission?.id)}
                  />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <Image
                      src={submission?.profilePhotoUrl || submission?.avatar || '/placeholder-avatar.png'}
                      alt={submission?.fullName || submission?.name || 'User'}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-medium text-foreground">{submission?.fullName || submission?.name || 'Unknown'}</p>
                      <p className="text-sm text-muted-foreground">{submission?.email || 'N/A'}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getCompanyColor(submission?.company?.name || submission?.company || 'Unknown')}`}>
                    {submission?.company?.name || submission?.company || 'Unknown'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground">{submission?.department || 'N/A'}</span>
                </td>
                <td className="px-6 py-4">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(submission?.submissionStatus || submission?.status || 'pending')}`}>
                    {(submission?.submissionStatus || submission?.status || 'pending')?.charAt(0)?.toUpperCase() + (submission?.submissionStatus || submission?.status || 'pending')?.slice(1)}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
                      <div 
                        className="h-full bg-primary transition-all"
                        style={{ width: `${submission?.completionRate || 0}%` }}
                      />
                    </div>
                    <span className="text-sm font-medium text-foreground">{submission?.completionRate || 0}%</span>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-muted-foreground">
                    {submission?.submittedAt ? new Date(submission?.submittedAt).toLocaleDateString() : submission?.submittedDate || 'N/A'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Eye"
                      onClick={() => onViewDetails(submission)}
                    />
                    {(submission?.submissionStatus || submission?.status) === 'pending' && (
                      <>
                        <Button
                          variant="ghost"
                          size="sm"
                          iconName="Check"
                          onClick={() => onApprove(submission?.id)}
                        />
                        <Button
                          variant="ghost"
                          size="sm"
                          iconName="X"
                          onClick={() => onReject(submission?.id)}
                        />
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubmissionTable;